// extracted by mini-css-extract-plugin
export default {"select":"_1IyBw"};